import dayjs from "dayjs";

export function getPastDueDays(input, key = "dueDate") {
  try {
    const value = typeof input === "object" && input !== null ? input[key] : input;
    if (!value || value === "-") { return "-"; }
    const dueDate = dayjs(value);
    if (!dueDate.isValid()) {
      console.warn("Invalid date passed to getPastDueDays:", value);
      return "-";
    }
    const today = dayjs().startOf("day");
    const normalizedDueDate = dueDate.startOf("day");
    const diff = today.diff(normalizedDueDate, "day");
    // if (diff < 0) {
    //   return diff;
    // }
    // return diff + 1;
    return diff;
  } catch (error) {
    console.error("Error in getPastDueDays:", error);
    return "-";
  }
}